<template>
<keep-alive>
  <PullRefresh v-model="isLoading" @refresh="onRefresh">
    <div class="accountrecorder">
        <topNav :title="title"></topNav>
        <div class="sectionContainer">
            <div class="no-record" v-show="parkingRecorder.length == 0">
                <img src="../../../static/images/no_record.png" alt="">
                <p>暂无停车记录</p>
            </div>
            <p class="month" v-show="parkingRecorder.length != 0">仅可查询最近15天已完成记录</p>

            <div class="sectionCount" v-for="(item, index) in parkingRecorder" :key="index">
                  <label class="bui-checkbox-label bui-checkbox-anim">
                      <div class="chooseicon" >
                        <input type="checkbox" @click="checkedRadioBtn(item)" v-model="item.checked">
                        <i class="bui-checkbox"  :class="item.checked? 'checked':''"></i>
                      </div>
                  </label>

                  <div class="recorder_info" @click="recorderdetail(item)">
                      <div class="parkingname">
                          <p class="parkings"><span>{{item.parkingname}}</span></p>
                          <div class="parkingprice">
                              <p class="parkingtime">停车时长：<span>{{item.parkingtimes}}</span></p>
                              <p class="parkingdate">出场时间：<span>{{item.dateOut}}</span></p>
                          </div>
                      </div>
                      <div class="money">
                          <p class="cardno">{{item.cardno}}</p>
                          <p><span>{{item.parkingfee}}</span>元</p>
                      </div>
                  </div>
            </div>
            <p v-show="parkingRecorderNone">暂无停车记录</p>
        </div>
    </div>
  </PullRefresh>
</keep-alive>



</template>
<script>
import topNav from "../topnav/topnav";
import { PullRefresh } from 'vant';
export default {
  name: 'accountrecorder',
  components:{
     topNav,
     PullRefresh,
  },
  data() {
    return {
      title:"停车记录",
      checkedAll:false,
      totalCount:0,
      totalMoney:0,
      totalRecorder:'',
      parkingRecorder:[],
      parkingRecorderNone:false,
      isLoading:false
    }
  },
  methods:{
    onRefresh(){//下拉刷新
      setTimeout(() => {
        this.isLoading = false;
        this.getRecorder();
      }, 500);
    },
    checkedRadioBtn:function(tabledatas){
      tabledatas.checked=!tabledatas.checked;
      this.countTotalMoney();
      if(this.totalCount==this.totalRecorder)
      {
        this.checkedAll=true;
      }
      else{
        this.checkedAll=false;
      }
    },
     /*计算商品总价函数*/
		countTotalMoney:function(){
			var _this = this;
      _this.totalMoney = 0;
      _this.totalCount = 0;
			this.parkingRecorder.forEach(function(item,index){
				if(item.checked == true){
          _this.totalMoney += parseInt(item.parkingfee);
          _this.totalCount +=1;
				}
      })
    },
    /*全选函数*/
		checkedAllBtn:function(checkedAll){
			var _this= this;
			/*全选计算商品或服务数量*/
			if(checkedAll == true){
				for(let x in this.parkingRecorder){
					this.parkingRecorder[x].checked = true;
				}
			}else{
				for(let y in this.parkingRecorder){
					this.parkingRecorder[y].checked = false;
				}
			}
			_this.countTotalMoney();
		},
    recorderdetail:function(item){
       this.$router.push({
         name: 'recorderdetail',
         params: {
           "cardno": item.cardno,
           "parkingfee": item.parkingfee,
           "parkingname": item.parkingname,
           "parkingtimes": item.parkingtimes,
           "dateOut": item.dateOut,
           "dateIn": item.dateIn,
           }
        })
    },
    getRecorder(){
      var url = this.url.url + "/api/js/out_in_record";
      var openId=sessionStorage.getItem("originalId");
      // var openId= 'o0b1TwWxOg7gmDXycxEUFXGO8MSI'
      var vehicleno=""
      var req = {
        openId: openId,
        vehicleno: vehicleno
      }
      
      this.$http({
          method: 'post',
          url: url,
          data: req,
          success: function(res){
              var _this=this;
              let arr = [];
              if(!res.data){
                this.$toast(res.msg)
                return
              }
              res.data.forEach(item => {
                let totalTimeM=item.parkingtimes;
                let totalMinute = totalTimeM % 60,
                totalHours = Math.floor(totalTimeM / 60);
                let totalTime = totalHours + "小时" + totalMinute + "分钟";
                let outdate = item.out_date,outtime = item.out_time;
                    let acoutdate = outdate.substring(0, 4) +
                      "-" +
                      outdate.substring(4, 6) +
                      "-" +
                      outdate.substring(6, 8);
                    let acouttime =
                      outtime.substring(0, 2) +
                      ":" +
                      outtime.substring(2, 4) +
                      ":" +
                      outtime.substring(4, 6);
                let dateOut = acoutdate + " " + acouttime;
                  let indate = item.in_date,
                      intime = item.in_time;
                    let acdate = indate.substring(0, 4) +
                      "-" +
                      indate.substring(4, 6) +
                      "-" +
                      indate.substring(6, 8);
                    let actime =
                      intime.substring(0, 2) +
                      ":" +
                      intime.substring(2, 4) +
                      ":" +
                      intime.substring(4, 6);
                    let dateIn = acdate + " " + actime;
                
                arr.push({
                "cardno":item.cardno,//车牌号
                'parkingfee':item.parkingfee,//支付金额
                'parkingname':item.parkingname,//停车场
                'parkingtimes':totalTime,//停车总时长
                'dateOut':dateOut,
                'dateIn':dateIn,
                'paymode':item.paymode,
                "checked":false
                })
                this.parkingRecorder = arr;
              })

            this.totalRecorder=this.parkingRecorder.length;
          }.bind(this),
          error: function(error){
              console.log(error);
          }
      })
    },
  },
  created(){
    this.getRecorder();
  }
}
</script>
<style lang="less" scoped>
.accountrecorder{
  min-height: 100vh;
  border-bottom:1px solid #fff;
  box-sizing: border-box;
}

label.bui-checkbox-label {
  input[type="checkbox"]{
    visibility: hidden;
    opacity: 0;
  }
  .chooseicon{
    display: flex;
    padding-top: 20px;
    .bui-checkbox{
      display: inline-block;
      position: relative;
      width: 15px;
      height: 15px;
      border: 1Px solid rgb(70, 135, 248);
      vertical-align: -2px;
      margin-right: 5px;
      border-radius: 100%;
    }
    .checked:after {
      position: absolute;
      content: "";
      width: 10px;
      height: 4px;
      border-left: 2px solid rgb(70, 135, 248);
      border-bottom: 2px solid rgb(70, 135, 248);
      transform: rotate(-45deg) translate(-50%, -50%);
      left: 50%;
    }
  }
  &.bui-checkbox-anim .bui-checkbox{
    transition: background-color ease-in-out 0.3s;
  }
}

.sectionContainer{
  .sectionCount{
    background: white;
    padding: 22px 0;
    margin-bottom: 5px;
    display: flex;
    label{
      display: flex;
    }
  }
  .month{
    text-align: left;
    padding:5px 0 5px  4%;
    font-size: 14px;
    color: #999;
  }
  .recorder_info{
    width: 100%;
    display: flex;
    .parkingname{
      width: 70%;
      text-align: left;
      padding-left: 10px;
      .parkingtime,.parkingdate{
        color:rgb(153,153,153);
        font-size: 14px;
        padding-top: 5px;
      }
    }
    .money{
      width: 30%;
      text-align: right;
      padding-right: 12px;
      .cardno{
        display: inline-block;
        border: 1px solid #e1e2e4;
        border-radius: 5px;
        font-size: 13px;
        padding: 2px;
        margin-left: 3px;
        vertical-align: 2px;
      }
      span{
        padding-right: 3px;
        color: #4687f8;
        padding-top: 9px;
        display: inline-block;
      }
    }
  }
}

.accountrecorder .no-record{
  img{
    width: 148px;
    height: 91px;
    margin-top: 60px;
  }
  p{
    font-size: 14px;
    color: rgb(154,154,154);
    line-height: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/my/accountrecorder.vue